import WorkIcon from '@mui/icons-material/Work';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import Payment from '@mui/icons-material/Payment';
import CampaignIcon from '@mui/icons-material/Campaign';
import DatasetIcon from '@mui/icons-material/Dataset';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { Person } from '@mui/icons-material';
import TocIcon from '@mui/icons-material/Toc';

export const menuItems = [
  {
    path: "/",
    icon: <Person />,
    linkText: "User Management",
  },
  {
    path: "/client-business",
    icon: <WorkIcon />,
    linkText: "Client Business",
  },
  {
    path: "/client-campaign",
    icon: <CampaignIcon />,
    linkText: "Assign Campaign",
  },
  {
    path: "/client-promocode",
    icon: <ConfirmationNumberIcon />,
    linkText: "Promocode",
  },
  {
    path: "/bin",
    icon: <Payment />,
    linkText: "Bin",
  },
  {
    path: "/view-campaign",
    icon: <DatasetIcon />,
    linkText: "Add & View Campaigns",
  },
  {
    path: "/content",
    icon: <TocIcon />,
    linkText: "CONTENT",
  },
  {
    path: "/ai-saas",
    icon: <AllInclusiveIcon />,
    linkText: "AI-SAAS",
  },
];